"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = exports.init = void 0;
const wasi_1 = require("@wasmer/wasi");
const utf8_1 = require("./utf8");
let wasmExports;
async function init(wasmFile) {
    if (wasmExports)
        return;
    let wasmModule;
    if (typeof wasmFile === "string") {
        try {
            wasmModule = await WebAssembly.compileStreaming(await fetch(wasmFile));
        }
        catch (e) {
            if (e instanceof TypeError) {
                wasmModule = await WebAssembly.compile(await (await fetch(wasmFile)).arrayBuffer());
            }
        }
    }
    else {
        wasmModule = await WebAssembly.compile(wasmFile);
    }
    const wasi = new wasi_1.WASI({
        args: [],
        env: {}
    });
    const wasm = await WebAssembly.instantiate(wasmModule, {
        wasi_snapshot_preview1: wasi.wasiImport
    });
    wasmExports = wasm.exports;
    wasi.setMemory(wasmExports.memory);
    wasmExports._initialize();
}
exports.init = init;
function writeEncodedString(str, memory, pointer) {
    const array = new Uint8Array(memory.buffer, pointer, str.byteLength + 1);
    for (let i = 0; i < str.length; i++)
        array[i] = str[i];
    array[str.length] = 0;
}
function readInt32(memory, pointer) {
    const array = new Uint32Array(memory.buffer, pointer, 1);
    return array[0];
}
function readString(memory, pointer) {
    let array = new Uint8Array(memory.buffer, pointer);
    let length = 0;
    while (array[length] !== 0)
        length++;
    if (length === 0)
        return "";
    array = new Uint8Array(memory.buffer, pointer, length);
    return utf8_1.decode(array);
}
function format(code, options) {
    if (!wasmExports) {
        throw new Error("Please call init() to load the WASM AStyle library first.");
    }
    const encodedCode = utf8_1.encode(code);
    const encodedOptions = utf8_1.encode(options);
    const bufferSize = encodedCode.byteLength + 1 + (encodedOptions.byteLength + 1) + 4;
    const bufferPointer = wasmExports.alloc_buffer(bufferSize);
    const resultBufferPointerBufferPointer = bufferPointer;
    const codePointer = resultBufferPointerBufferPointer + 4;
    const optionsPointer = codePointer + (encodedCode.byteLength + 1);
    writeEncodedString(encodedCode, wasmExports.memory, codePointer);
    writeEncodedString(encodedOptions, wasmExports.memory, optionsPointer);
    const success = !!wasmExports.wastyle(codePointer, optionsPointer, resultBufferPointerBufferPointer);
    const resultBufferPointer = readInt32(wasmExports.memory, resultBufferPointerBufferPointer);
    const result = readString(wasmExports.memory, resultBufferPointer);
    wasmExports.free_buffer(bufferPointer);
    if (resultBufferPointer)
        wasmExports.free_buffer(resultBufferPointer);
    return [success, result];
}
exports.format = format;
//# sourceMappingURL=index.js.map